import {
  AnalyticsActions,
  AnalyticsActionTypes,
  apiRequest,
  hideLoader,
  setAnalytics,
  setAnalyticsError,
  setDocuments,
  setSchema,
  showLoader,
} from '../actions'
import { Schema } from '../schemas'
import { analyticsTitleSelector, focusedOrgSelector } from '../selectors'
import { Middleware } from '../store'
import { V2Response } from '../types'

export const analyticsMiddleware: Middleware<AnalyticsActions> = ({ dispatch, getState }) => (next) => (action) => {
  next(action)

  switch (action.type) {
    case AnalyticsActionTypes.GET_ANALYTICS:
      const org = focusedOrgSelector(getState())
      if (!org) {
        break
      }
      dispatch(
        apiRequest({
          url: `/organizations/${org.trunkID}/${org.ID}/analytics/${action.dashboardType}`,
          method: 'GET',
          feature: AnalyticsActionTypes.GET_ANALYTICS,
        })
      )
      break

    case AnalyticsActionTypes.GET_ANALYTICS_SUCCESS:
      // set totalCount to -1 so the AppBar Title doesn't display a count
      dispatch(
        setDocuments(({
          totalCount: -1,
        } as unknown) as V2Response)
      )
      // the AppBar needs a title for analytics
      dispatch(
        setSchema({
          label: analyticsTitleSelector(getState()),
        } as Schema)
      )
      dispatch(setAnalytics(action.payload))
      break

    case AnalyticsActionTypes.GET_ANALYTICS_ERROR:
      dispatch(setAnalyticsError(action.payload))
      break

    case AnalyticsActionTypes.ERROR_ANALYTICS:
      const error = action.payload
      if (error) {
        console.error('error handling looker', error._message)
      }
      dispatch(hideLoader(AnalyticsActionTypes.GET_ANALYTICS))
      dispatch(hideLoader(AnalyticsActionTypes.GET_LOOKER_TOKENS))
      break

    case AnalyticsActionTypes.GET_LOOKER_TOKENS:
      dispatch(showLoader(AnalyticsActionTypes.GET_LOOKER_TOKENS))
      break

    case AnalyticsActionTypes.SET_LOOKER_TOKENS:
      dispatch(hideLoader(AnalyticsActionTypes.GET_ANALYTICS))
      dispatch(hideLoader(AnalyticsActionTypes.GET_LOOKER_TOKENS))
      break
  }
}
